// DS: C33D
// zeplin: https://zpl.io/25JBpGn
import React from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import s from './CollectionCardFooter.scss';
const CollectionCardFooter = ({ gallection  })=>{
    const { name , size  } = gallection;
    const { t  } = useTranslation();
    return /*#__PURE__*/ React.createElement(Flex, {
        className: s['root'],
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['name']
    }, name), /*#__PURE__*/ React.createElement("div", {
        className: s['size']
    }, t('collectionCard.artworkStat', {
        formattedCount: shortenNumber(size, 0),
        count: size
    })));
};
CollectionCardFooter.displayName = 'CollectionCardFooter';
export default CollectionCardFooter;
